import api from "./api";

async function getCheckout(id) {
  try {
    const response = await api.get(`api/checkouts/${id}`);
    return response.data;
  } catch (error) {
    return [];
  }
}

export { getCheckout };
